<template>
  <div class="relative inline-block">
    <Float portal show :placement="position" auto-placement :offset="5">
      <div
        class="pointer-events-auto text-[0] focus:outline-none"
        @mouseenter="hoverPopover"
        @mouseleave="closePopover"
      >
        <slot name="label" />
      </div>
      <!-- DO NOT REMOVE THIS EMPTY DIV - IT IS NEEDED BY FLOATING-UI -->
      <div>
        <transition
          enter-active-class="transition ease-out duration-200"
          enter-from-class="opacity-0 translate-y-1"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class="transition ease-in duration-150"
          leave-from-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 translate-y-1"
        >
          <div
            v-if="isPopoverVisible"
            :class="[position === 'left' ? 'right-full' : 'left-full']"
            :style="`min-width: ${minWidth}px`"
            class="pointer-events-auto top-0 z-20 ml-0 w-auto px-2 sm:px-0"
            @mouseover="!disabled ? (isHovering = true) : null"
            @mouseleave="leavePanel"
          >
            <div
              class="mx-2 overflow-hidden rounded-md bg-white text-sm leading-6 shadow-lg ring-1 ring-black/5"
            >
              <div class="relative grid gap-1 bg-white p-5">
                <slot name="content" />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </Float>
  </div>
</template>

<script setup lang="ts">
import type { PopoverPosition } from '@/types';

const props = defineProps({
  position: {
    type: String as PropType<PopoverPosition>,
    default: 'left',
  },
  minWidth: {
    type: String,
    default: '320',
  },
  hasDelay: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const popoverTimeout = ref<NodeJS.Timeout>();
const hoverTimeout = ref<NodeJS.Timeout>();
const isPopoverVisible = ref(false);
const isHovering = ref(false);

const hoverPopover = () => {
  if (props.disabled) {
    return;
  }
  hoverTimeout.value = setTimeout(() => {
    isPopoverVisible.value = true;
  }, 200);
};

const leavePanel = () => {
  if (props.disabled) {
    return;
  }
  isHovering.value = false;
  closePopover();
};

const closePopover = () => {
  if (props.disabled) {
    return;
  }

  if (hoverTimeout.value) {
    clearTimeout(hoverTimeout.value);
  }

  if (popoverTimeout.value) {
    clearTimeout(popoverTimeout.value);
  }

  popoverTimeout.value = setTimeout(() => {
    if (!isHovering.value) {
      isPopoverVisible.value = false;
    }
  }, 100);
};
</script>
